import type { FaireProductEntity } from "../../entity_types/product";

export const p_5x5e94shbt: FaireProductEntity = {
  token: "p_5x5e94shbt",
  type: "product",
  name: "Rye Jug / Carafe / Pitcher",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/e9407ba3df9fc39b92dff66e6666f3583bad388ab86d5410554a94f735de0c7e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/178b2d25aaad1ff15ee39b6c9cc5a329b5e8304a834755ad4b03070e8f61f633.jpeg",
    "https://cdn.faire.com/fastly/b0d3f3f9d2b68e67365d2d8007d46607040f4445c769caca5002a4684805d0b2.jpeg",
    "https://cdn.faire.com/fastly/bee85c75d50e96aa005a07f3b2c6e9c9c9358cc8948c001446c5b6b7d7a091c6.jpeg",
    "https://cdn.faire.com/fastly/436c06a9d5c8764c84f6c0dcab645b9e04e38b560bc55cf7caae127fba64d5b2.jpeg",
    "https://cdn.faire.com/fastly/1376dc2025c24652ab26bb664129561c53f4baf11072e8668b9885760074ff26.jpeg",
    "https://cdn.faire.com/fastly/2f88c78ed97ab393de926bec254613aeb953cb59fc64fd8a7cf2e63ed306c7c7.jpeg",
  ],
  priceDollars: 27.5,
  description:
    'RYE glassware range has been designed to elevate the drinking experience, whether it is water, beer, wine or a meticulously mixed cocktail. The glasses are skilfully hand crafted from a robust borosilicate glass. The range is well-proportioned, graphic in form, and the subtle accent of coloured glass elevates the drink whilst still allowing you to appreciate the shade of the drink.\n\n• Size: D 10cm x H 24cm / D 3.9" x H 9.45"\n• Capacity: 1300ml / 44 fl oz\n\n• Colour: clear + smoke\n\nPerfect addition to Autumn / Fall / Christmas / Holiday / Thanksgiving season collection!',
  tags: [],
  msrpDollars: 55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:29.626Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
